import { useCallback, useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import {
	HiMiniRectangleGroup,
	HiChevronUpDown,
	HiListBullet,
	HiMiniChevronRight,
	HiMiniStar,
	HiMiniChevronUp,
	HiChartBar,
	HiMiniUserGroup,
	HiClock,
	HiMiniPuzzlePiece,
	HiChatBubbleLeftRight,
	HiMiniFlag,
	HiMiniChatBubbleLeftEllipsis,
	HiMiniHandThumbUp,
	HiMiniScale,
} from 'react-icons/hi2'
import { useIntl } from 'react-intl'

import { ModalFeedback } from '../../Components/Feedbacks/modalFeedback'
import Loading from '../../Components/Loading/Loading'

import FeedbacksApi from '../../API/Employee/Feedback'
import employeeFeedbackMapper from '../../Utils/EmployeeFeedbackMapper.js'

import { Select } from '../../Components/Employee/Select/Select'

const categories = {
	1: { color: '#6C4FDB', icon: <HiChatBubbleLeftRight size={20} color='#6C4FDB' />, name: { pt: 'Comunicação', es: 'Comunicación' } },
	2: { color: '#6C4FDB', icon: <HiMiniUserGroup size={20} color='#6C4FDB' />, name: { pt: 'Trabalho em equipe', es: 'Trabajo en equipo' } },
	3: { color: '#008ACD', icon: <HiChartBar size={20} color='#008ACD' />, name: { pt: 'Produtividade', es: 'Productividad' } },
	4: { color: '#6C4FDB', icon: <HiMiniFlag size={20} color='#6C4FDB' />, name: { pt: 'Liderança', es: 'Liderazgo' } },
	5: {
		color: '#00A28B',
		icon: <HiMiniPuzzlePiece size={20} color='#00A28B' />,
		name: { pt: 'Adaptabilidade e Flexibilidade', es: 'Adaptabilidad y flexibilidad' },
	},
	6: {
		color: '#D87706',
		icon: <HiMiniPuzzlePiece size={20} color='#00A28B' />,
		name: { pt: 'Competências técnicas', es: 'Competencias técnicas' },
	},
	7: {
		color: '#D87706',
		icon: <HiMiniRectangleGroup size={20} color='#D87706' />,
		name: { pt: 'Orientação ao cliente', es: 'Orientación al cliente' },
	},
	8: { color: '#D87706', icon: <HiClock size={20} color='#D87706' />, name: { pt: 'Pontualidade', es: 'Puntualidad' } },
	9: {
		color: '#D87706',
		icon: <HiMiniRectangleGroup size={20} color='#D87706' />,
		name: { pt: 'Responsabilidade e Comprometimento', es: 'Responsabilidad y compromiso' },
	},
	10: { color: '#00A28B', icon: <HiMiniHandThumbUp size={20} color='#00A28B' />, name: { pt: 'Atitude', es: 'Actitud' } },
	11: { color: '#00A28B', icon: <HiMiniScale size={20} color='#00A28B' />, name: { pt: 'Ética e integridade', es: 'Ética e integridad' } },
	12: {
		color: '#6C4FDB',
		icon: <HiMiniChatBubbleLeftEllipsis size={20} color='#6C4FDB' />,
		name: { pt: 'Gestão de conflitos', es: 'Gestión de conflictos' },
	},
	13: { color: '#008ACD', icon: <HiClock size={20} color='#008ACD' />, name: { pt: 'Gestão de tempo', es: 'Gestión del tiempo' } },
	14: {
		color: '#008ACD',
		icon: <HiMiniRectangleGroup size={20} color='#008ACD' />,
		name: { pt: 'Resolução de problemas', es: 'Resolución de problemas' },
	},
	15: { color: '#00A28B', icon: <HiMiniRectangleGroup size={20} color='#00A28B' />, name: { pt: 'Proatividade', es: 'Proactividad' } },
}

export function FeedbackReceived() {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const [modalFeedback, setModalFeedback] = useState(false)
	const [categorySelected, setCategorySelected] = useState(null)
	const [feedbackData, setFeedbackData] = useState(null)
	const [type, setType] = useState('')

	const [list, setList] = useState(null)
	const [selected, setSelected] = useState(null)
	const [loadingData, setLoadingData] = useState(false)

	const loadData = useCallback(async () => {
		try {
			const { id } = JSON.parse(localStorage.getItem('user'))
			const response = await FeedbacksApi.getAllEmployeeWithFeedbacksReceiver(id)
			setList(response.map(employeeFeedbackMapper.toDomain))
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSelect = async event => {
		try {
			setLoadingData(true)
			setSelected(event.target)
			const response = await FeedbacksApi.getFeedbacksReceived(event.target.value)
			setFeedbackData(Object.entries(response))
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		} finally {
			setLoadingData(false)
		}
	}

	const order = type => {
		setType(type)
		const sortedData = [...feedbackData].sort(([, a], [, b]) => b[type] - a[type])
		setFeedbackData(sortedData)
	}

	if (!list) return <Loading />

	return (
		<div className='tw-pr-8'>
			<h1 className='tw-text-2xl tw-font-bold tw-mb-4'>Feedbacks Recebidos</h1>
			<div className='tw-mb-5 tw-mt-5'>
				<Select placeholder='Colaborador' list={list} onChange={handleSelect} name='employee' value={selected?.value} />
			</div>

			{!selected ? (
				<div className='tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-gray-100 tw-p-4 tw-space-y-5 tw-h-[75vh]'>
					<div className='tw-font-bold tw-text-xl'>Seleccione un colaborador para ver sus feedbacks recebidos.</div>
				</div>
			) : (
				<>
					{loadingData && (
						<div>
							<Loading />
						</div>
					)}
					{!loadingData && (
						<table className='tw-w-full tw-border-collapse tw-table-auto'>
							<thead>
								<tr className='tw-bg-gray-100 tw-text-sm'>
									<th className='tw-p-4 tw-text-left tw-font-medium'>
										<button
											onClick={() => order('feedbacks')}
											className='border-0 tw-bg-transparent tw-text-base tw-flex tw-items-center tw-gap-1'
										>
											<HiListBullet className='tw-text-gray-500 tw-mr-1 tw-text-base' />
											<span className='tw-text-sm'>Categoria</span>
											{type === 'feedbacks' ? (
												<HiMiniChevronUp size={12} className='tw-text-gray-800' />
											) : (
												<HiChevronUpDown className='tw-text-gray-800' />
											)}
										</button>
									</th>

									<th className='tw-p-4 tw-text-left tw-font-medium'>
										<button
											onClick={() => order('rating')}
											className='border-0 tw-bg-transparent tw-text-base tw-flex tw-items-center tw-gap-1'
										>
											<HiMiniStar className='tw-text-gray-500 tw-mr-1' />
											<span className='tw-text-sm'>Evaluacion Média</span>
											{type === 'rating' ? (
												<HiMiniChevronUp className='tw-text-gray-800' />
											) : (
												<HiChevronUpDown className='tw-text-gray-800' />
											)}
										</button>
									</th>
									<th className='tw-p-4 tw-text-left tw-font-medium'></th>
								</tr>
							</thead>
							<tbody>
								{feedbackData?.map(item => (
									<tr key={item[0]} className='border-b last:border-0 hover:tw-bg-gray-50 border-bottom'>
										<td className='tw-p-4 tw-font-medium '>
											<div className='tw-w-full tw-flex tw-items-center tw-gap-2 '>
												<span>{categories[item[0]].icon}</span>
												{categories[item[0]].name[language]}
												<span className='tw-bg-gray-200 tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-text-gray-700'>
													{item[1].feedbacks}
												</span>
											</div>
										</td>
										<td className='tw-p-4 tw-text-left'>
											<div className='tw-flex tw-items-center tw-space-x-3'>
												<span className='tw-font-bold'>{item[1].rating.toFixed(1)}</span>
												<div>
													{Array.from({ length: 5 }).map((_, index) => (
														<span
															key={index}
															className={` tw-text-lg ${
																index < Math.floor(item[1].rating) ? 'tw-text-alert-300' : 'tw-text-gray-300'
															}`}
														>
															<HiMiniStar />
														</span>
													))}
												</div>
											</div>
										</td>
										<td className='tw-p-4 tw-text-left'>
											<button
												onClick={() => {
													setModalFeedback(true)
													setCategorySelected(item[0])
												}}
												className='border-0 tw-px-4 tw-py-2 tw-rounded-md tw-text-sm tw-text-purple tw-bg-purple-50'
											>
												Ver feedbacks <HiMiniChevronRight />
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					)}
				</>
			)}
			{modalFeedback && (
				<>
					<ModalFeedback
						target={{ id: selected.value }}
						categories={categories}
						close={() => setModalFeedback(false)}
						type='received'
						categorySelected={categorySelected}
					/>
				</>
			)}
		</div>
	)
}
